import { render, staticRenderFns } from "./errorPage.vue?vue&type=template&id=59630595&scoped=true"
import script from "./errorPage.vue?vue&type=script&lang=js"
export * from "./errorPage.vue?vue&type=script&lang=js"
import style0 from "./errorPage.vue?vue&type=style&index=0&id=59630595&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59630595",
  null
  
)

export default component.exports